import React from 'react';
import {Helmet} from 'react-helmet';

const GiccMeta = () => {
  return (
    <Helmet>
      <title>ศูนย์รวมสินค้าไอที คอมประกอบ Notebook สมาร์ทโฟน ราคาดีที่ BKK IT</title>
      <meta name="title" content="ศูนย์รวมสินค้าไอที คอมประกอบ Notebook ผ่อน 0% ราคาดีที่ BKK IT" />
      <meta
        name="description"
        content="BKK IT, ,คอมพิวเตอร์,ไอที่,COMPUTER ,SOFTWARE ,ซอร์ฟแวร์ ,HARDWARE, ฮาร์ดแวร์,NOTEBOOK,PC,พีซี,MAINBOARD,เมนบอร์ด,CPU,ซีพียู,RAM,แรม,HARD,DISK,ฮาร์ดดิสก์ ,THUMB,DRIVE,FLAST,SET,SPEC,ประกอบคอม,จัดสเป็คคอม,โน้ตบุ๊ค แท็บเล็ต tablet, สมาร์ทโฟน Smartphone,โปรโมชั่น Promotion,Online ออนไลน์"
      />
      <meta
        name="keywords"
        content="BKK IT,คอมพิวเตอร์,ไอที่,COMPUTER ,SOFTWARE ,ซอร์ฟแวร์ ,HARDWARE, ฮาร์ดแวร์,NOTEBOOK,PC,พีซี,MAINBOARD,เมนบอร์ด,CPU,ซีพียู,RAM,แรม,HARD,DISK,ฮาร์ดดิสก์ ,THUMB,DRIVE,FLAST,SET,SPEC,ประกอบคอม,จัดสเป็คคอม,โน้ตบุ๊ค แท็บเล็ต tablet, สมาร์ทโฟน Smartphone,โปรโมชั่น Promotion,Online ออนไลน์"
      />
      <meta name="author" content="BKK IT" />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="%REACT_APP_WEB_URL%" />
      <meta property="og:title" content="ศูนย์รวมสินค้าไอที คอมประกอบ Notebook ผ่อน 0% ราคาดีที่ BKK IT" />
      <meta
        property="og:description"
        content="BKK IT, ,คอมพิวเตอร์,ไอที่,COMPUTER ,SOFTWARE ,ซอร์ฟแวร์ ,HARDWARE, ฮาร์ดแวร์,NOTEBOOK,PC,พีซี,MAINBOARD,เมนบอร์ด,CPU,ซีพียู,RAM,แรม,HARD,DISK,ฮาร์ดดิสก์ ,THUMB,DRIVE,FLAST,SET,SPEC,ประกอบคอม,จัดสเป็คคอม,โน้ตบุ๊ค แท็บเล็ต tablet, สมาร์ทโฟน Smartphone,โปรโมชั่น Promotion,Online ออนไลน์"
      />
      <meta property="og:image" content="%REACT_APP_WEB_URL%/logo.png" />

      <meta name="twitter:site" content="@%REACT_APP_DISPLAY_NAME%" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="%REACT_APP_WEB_URL%" />
      <meta property="twitter:title" content="ศูนย์รวมสินค้าไอที คอมประกอบ Notebook ผ่อน 0% ราคาดีที่ BKK IT" />
      <meta
        property="twitter:description"
        content="BKK IT, คอมพิวเตอร์,ไอที่,COMPUTER ,SOFTWARE ,ซอร์ฟแวร์ ,HARDWARE, ฮาร์ดแวร์,NOTEBOOK,PC,พีซี,MAINBOARD,เมนบอร์ด,CPU,ซีพียู,RAM,แรม,HARD,DISK,ฮาร์ดดิสก์ ,THUMB,DRIVE,FLAST,SET,SPEC,ประกอบคอม,จัดสเป็คคอม,โน้ตบุ๊ค แท็บเล็ต tablet, สมาร์ทโฟน Smartphone,โปรโมชั่น Promotion,Online ออนไลน์"
      />
      <meta property="twitter:image" content="%REACT_APP_WEB_URL%/logo.png" />
      <meta name="twitter:domain" content="%REACT_APP_WEB_URL%" />
    </Helmet>
  );
};

export default GiccMeta;
